var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z","fill":"#133036"}})
}
var staticRenderFns = []

export { render, staticRenderFns }